const bottombar = () => {
    if ($(".bottom-bar-wrap").length == 0) return;

    if($(".bottom-bar-wrap").css('dispalay') !== 'none') {
        $(".footer-call").css({
            bottom: 80
        })
    }

    //default active
    activeItem($(".bottom-bar-wrap .item.active"));

    $(".bottom-bar-wrap").on('click', '.btn-show-full', function () {
        const $parent = $(this).parents(".bottom-bar-wrap");
        $parent.find(".bottom-bar-show").toggleClass("full")
        // $(".footer-call").toggleClass("d-none");
    })
    $(".bottom-bar-wrap").on('focusout', function () {
        $(this).find(".bottom-bar-show").removeClass("full")
        // $(".footer-call").removeClass("d-none");
    })

    $(".bottom-bar-wrap").on('click', '.full .item', function () {
        const $parent = $(this).parents(".bottom-bar-wrap");
        const goto = $(this).data("goto")
        const isRedirect = $parent.data("no-scroll")
        const index = $(this).index()
        activeItem(this);

        $parent.attr("disableScrollCheck", "1");
        setTimeout(() => {
            $parent.attr("disableScrollCheck", "0");
        }, 1000)
        if (isRedirect) {
            window.location.href = goto
        }
        else {
            //$('html, body').scrollTop($(goto).offset().top + $(".header-menu").position().top - 50)
            $('html, body').animate({
                scrollTop:$(goto).offset().top + $(".header-menu").position().top - 50
              }, 800);
        }
        $parent.find(".bottom-bar-show").removeClass("full")
    })

    $(window).on('scroll', function () {
        if ($(window).width() >= 1024) return;
        
        if($(".bottom-bar-wrap").data("no-scroll") == '1') {

            return;
        }

        $(".bottom-bar-wrap .item").each(function (e) {
            if ($(".bottom-bar-wrap").attr("disableScrollCheck") == "1") return;
            const goto = $(this).data("goto");
            const top = $(goto).offset()?.top || 0;
            const start = top - 100;
            const end = top + $(goto).height();
            const currentScroll = $(window).scrollTop() + $(window).height() / 2;

            if (currentScroll > start && currentScroll < end) {
                if (!$(this).hasClass('active')) {
                    activeItem(this);
                }
            }
            else if ($(this).hasClass("active")) {
                $(this).removeClass("active")
            }
        })
        if ($(".bottom-bar-wrap .item.active").length > 0) {
            $(".bottom-bar-wrap").css({
                bottom: 0
            })
            $(".footer-call").css({
                bottom: 80
            })
        }
        else {
            $(".bottom-bar-wrap").css({
                bottom: -80
            })
            $(".footer-call").css({
                bottom: 0
            })
        }
    })
}

const activeItem = (element) => {
    const $parent = $(element).parents(".bottom-bar-wrap");
    const goto = $(element).data("goto")
    const index = $(element).index()

    $parent.find(".item.active").removeClass("active")

    $(element).addClass("active")
    $parent.find(".list-item").css({
        bottom: 80 * index
    })
}

module.exports = bottombar